module.exports = __webpack_public_path__ + "static/media/ic_long_menu.ef3bf3be.svg";